module.exports = __webpack_public_path__ + "img/main_logo.81fea75f.png";